import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";
import type CnamProcessStartedJournalEvent from "./cnam-process-started-journal-event";
import type TimedTransaction from "./timed-transaction";

//---- Automatically generated, don't update this part ----

export default class CnamProcessEndedJournalEvent extends JournalEvent {
  static override type = "cnam-process-ended-journal-event";

  @belongsTo("cnam-process-started-journal-event", {
    async: false,
    inverse: "cnamProcessEndedJournalEvent"
  })
  declare cnamProcessStartedJournalEvent: CnamProcessStartedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.cnam-process-ended-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @attr("timed-transactions") declare timedTransactions: TimedTransaction[];
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "cnam-process-ended-journal-event": CnamProcessEndedJournalEvent;
  }
}
